const WorkOrderItemStatusEnum = {
  Pending: 1,
  Executed: 2,
  NotExecuted: 3
};

const WorkOrderItemStatusList = [
  { id: WorkOrderItemStatusEnum.Pending, label: "Pendente", variant: "secondary" },
  { id: WorkOrderItemStatusEnum.Executed, label: "Executada", variant: "success" },
  {
    id: WorkOrderItemStatusEnum.NotExecuted,
    label: "Não executada",
    variant: "danger"
  }
];

const WorkOrderItemStatus = {
  Enum: WorkOrderItemStatusEnum,
  List: WorkOrderItemStatusList,

  Label(status) {
    let item = WorkOrderItemStatusList.find((x) => x.id === status);
    return item ? item.label : "";
  },

  Variant(status) {
    let item = WorkOrderItemStatusList.find((x) => x.id === status);
    return item ? item.variant : "secondary";
  }
};

export default WorkOrderItemStatus;
